import * as API from '@/api'
import { user } from '@/services'

const CHANGE_STUDENTS_SELECTION = 'CHANGE_STUDENTS_SELECTION'
const ERROR = 'ERROR'
const FETCH_RESPONSIBLE_INFOS = 'FETCH_RESPONSIBLE_INFOS'
const IS_LIST_READY_TO_SHOW = 'IS_LIST_READY_TO_SHOW'
const LOADING = 'LOADING'
const UPDATE_STUDENT_CHECKED = 'UPDATE_STUDENT_CHECKED'
const WIPE_MAIN_DATA = 'WIPE_MAIN_DATA'
const WITHOUT_STUDENTS = 'WITHOUT_STUDENTS'
const SET_STUDENTS = 'SET_STUDENTS'
const SEND_STUDENTS_MESSAGE = 'SEND_STUDENTS_MESSAGE'

const initialState = {
  data: {},
  students: [],
  document: '',
  error: null,
  isAllStudentsSelected: true,
  isListReadyToShow: false,
  loading: false,
  sendStudentsMessage: null,
  withoutStudents: false
}

const state = { ...initialState }

const mutations = {

  [SET_STUDENTS]: function (state, value) {
    state.students = value
  },

  [CHANGE_STUDENTS_SELECTION]: function (state, value) {
    state.isAllStudentsSelected = !state.isAllStudentsSelected
    state.students = state.students.map(student => {
      student.checked = state.isAllStudentsSelected
      return student
    })
  },

  [ERROR]: function (state, value) {
    state.error = value
  },

  [FETCH_RESPONSIBLE_INFOS]: function (state, data) {
    state.data = data
  },

  [WITHOUT_STUDENTS]: function (state, value) {
    state.withoutStudents = value
  },

  [IS_LIST_READY_TO_SHOW]: function (state, value) {
    state.isListReadyToShow = value
  },

  [LOADING]: function (state, value) {
    state.loading = value
  },

  [SEND_STUDENTS_MESSAGE]: function (state, value) {
    state.sendStudentsMessage = value
  },

  [UPDATE_STUDENT_CHECKED]: function (state, { id, value }) {
    state.students = state.students.map(student => {
      if (student.id === id) {
        student.checked = value
      }
      return student
    })

    if (state.students.filter(s => s.checked === true).length === state.students.length) {
      state.isAllStudentsSelected = true
    } else {
      state.isAllStudentsSelected = false
    }
  },

  [WIPE_MAIN_DATA]: function (state) {
    state.data = initialState.data
    state.isAllStudentsSelected = initialState.isAllStudentsSelected
    state.document = initialState.document
    state.isListReadyToShow = initialState.isListReadyToShow
    state.students = initialState.students
    state.error = initialState.error
  }
}

const actions = {
  fetchResponsibleInfos ({ commit, dispatch }, document) {
    commit(LOADING, true)
    commit(IS_LIST_READY_TO_SHOW, false)
    commit(ERROR, null)

    const building = user.getSelectedBuilding().value

    API.exitRequest.responsibleInfos.getResponsibleInfos(document, building)
      .then(response => {
        dispatch('presetResponsibleInfosData', response.data)
      })
      .catch(error => {
        commit(ERROR, error)
      })
      .finally(() => {
        commit(IS_LIST_READY_TO_SHOW, true)
        commit(LOADING, false)
      })
  },

  presetResponsibleInfosData ({ commit }, data) {
    if (data.students.length > 0) {
      commit(WITHOUT_STUDENTS, false)
      commit(WIPE_MAIN_DATA, null)

      const temporaryStudents = data.temporary_students.map(temporaryStudent => {
        temporaryStudent.temporary = true
        temporaryStudent.checked = true
        return temporaryStudent
      })

      const students = data.students.map(student => {
        student.temporary = false
        student.checked = true
        return student
      })

      commit(SET_STUDENTS, students.concat(temporaryStudents))
    } else {
      commit(WITHOUT_STUDENTS, true)
    }

    commit(FETCH_RESPONSIBLE_INFOS, data)
  },

  updateStudentChecked ({ commit }, payload) {
    commit(UPDATE_STUDENT_CHECKED, payload)
  },

  changeStudentsSelection ({ commit }, payload) {
    commit(CHANGE_STUDENTS_SELECTION, payload)
  },

  sendStudents ({ commit }, payload) {
    commit(SEND_STUDENTS_MESSAGE)
    API.exitRequest.responsibleInfos.sendExitRequest(payload)
      .then(response => {
        commit(WIPE_MAIN_DATA)
        commit(SEND_STUDENTS_MESSAGE, 'Solicitação enviada com sucesso')
      })
      .catch(() => {
        commit(SEND_STUDENTS_MESSAGE, 'Erro ao enviar solicitação')
      })
  },

  resetStore ({ commit }) {
    commit(WIPE_MAIN_DATA, null)
  }
}

const getters = {
  getStudentsRequestData (state) {
    let studentsIds = []

    state.students
      .filter(student => student.checked)
      .map(student => { studentsIds.push(student.id) })

    const { id } = user.getUserData()
    const responsibleId = state.data.id

    return {
      id,
      responsibleId,
      studentsIds
    }
  },

  getSelectedStudents (state) {
    return (state.students || []).filter(student => student.checked)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
